import { CheckboxFilter, type Option } from '@lifebit-ai/lds'
import React from 'react'

import { useGetDataAccessRequestLabelsFilter } from 'services/data-access-requests/hooks/useGetDataAccessRequestLabelsFilter'

interface DataAccessRequestLabelsFilterProps {
  onApply: (filteredOptions: Option[]) => void
  onReset: () => void
}

export const DataAccessRequestLabelsFilter = ({ onApply, onReset }: DataAccessRequestLabelsFilterProps) => {
  const labelsQuery = useGetDataAccessRequestLabelsFilter()

  const options: Option[] =
    labelsQuery.data?.data.map(label => ({
      label: label.name,
      value: label._id
    })) ?? []

  return (
    <CheckboxFilter
      label="Labels"
      loading={labelsQuery.isLoading}
      onApply={onApply}
      options={options}
      onReset={onReset}
      searchFieldPlaceholder="Search labels"
    />
  )
}
